import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Button from '@mui/material/Button';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { buttonSx, textSx } from './styles';

export default function ViewButton() {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation();

  return (
    <Button onClick={() => setExpanded((prev) => !prev)} data-testid='view-button' sx={buttonSx}>
      <Typography variant='button' sx={textSx}>
        {expanded ? t('admin.centralReportsPage.viewLess') : t('admin.centralReportsPage.viewMore')}
      </Typography>
      {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
    </Button>
  );
}
